export interface BatchTrcBooksAndAvUpdateRequest {
  startNumFrom: string
  startNumTo: string
  searchType: string
  isReplaceAuthority: boolean
  convertHyoukiToFull: boolean
  convertKanaToHalf: boolean
  inputFileMarc: string
  memo: string
  batchType: string
}

export function BatchTrcBooksAndAvUpdateRequestToJSON(
  value: BatchTrcBooksAndAvUpdateRequest
): any {
  return {
    start_num_from: value.startNumFrom,
    start_num_to: value.startNumTo,
    search_type: value.searchType,
    is_replace_authority: value.isReplaceAuthority,
    convert_hyouki_to_full: value.convertHyoukiToFull,
    convert_kana_to_half: value.convertKanaToHalf,
    input_file_marc: value.inputFileMarc,
    memo: value.memo,
    batch_type: value.batchType
  }
}
